import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import type { SvgIconComponent } from "@mui/icons-material";

const EXTENSION_ICON_MAP: Record<string, SvgIconComponent> = {
  pdf: PictureAsPdfOutlinedIcon,
  xlsx: TableChartOutlinedIcon,
  jpg: ImageOutlinedIcon,
  jpeg: ImageOutlinedIcon,
  png: ImageOutlinedIcon,
  webp: ImageOutlinedIcon,
  txt: DescriptionOutlinedIcon,
  doc: DescriptionOutlinedIcon,
  docx: DescriptionOutlinedIcon,
  ppt: SlideshowOutlinedIcon,
  pptx: SlideshowOutlinedIcon,
};

export function getFileExtensionIcon(extension: string): SvgIconComponent {
  return EXTENSION_ICON_MAP[extension.toLowerCase()] ?? InsertDriveFileOutlinedIcon;
}
